import requestCanceler from "@/api/requestCancel";
import { useTokenStore } from "@/stores/token";
import LoginView from "@/views/LoginView.vue";
import { createRouter, createWebHistory } from "vue-router";

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: "/login",
      name: "login",
      alias: "/",
      component: LoginView,
      meta: { requiredLogin: false },
    },
    {
      path: "/login/:id/:pw",
      name: "autoLogin",
      component: LoginView,
      meta: { requiredLogin: false },
    },
    {
      path: "/camList",
      name: "camList",
      component: () => import("@/views/CamListView.vue"),
    },
    {
      path: "/readCamQR",
      name: "readCamQR",
      component: () => import("@/views/ReadCamQRView.vue"),
    },
    {
      path: "/confirmSys",
      name: "confirmSys",
      component: () => import("@/views/ConfirmSysView.vue"),
    },
    {
      path: "/camSetupComp",
      name: "camSetupComp",
      component: () => import("@/views/CamSetupCompView.vue"),
    },
    {
      path: "/SettingRemoteCenter",
      name: "SettingRemoteCenter",
      component: () => import("@/views/SettingRemoteCenterView.vue"),
    },
    {
      path: "/Interruption",
      name: "Interruption",
      component: () => import("@/views/InterruptionView.vue"),
    },
  ],
  scrollBehavior(to, from, savedPosition) {
    return { top: 0 };
  }
});

router.beforeEach((to, from, next) => {
  const token = useTokenStore();
  console.log("Router.beforeEach");
  requestCanceler.cancel();
  if (token.idTokenExp < new Date().getTime() / 1000) {
    if (to.meta.requiredLogin !== false) {
      return next({
        name: "login",
        query: {
          ref: to.fullPath,
        },
      });
    }
  }

  return next();
});

export default router;
